var _rect, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#006fcf"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.71 16.79 4 25.21 8.21 25.21 8.22 25.18 8.69 23.89 9.54 23.89 10.39 23.89 10.86 25.18 10.87 25.21 12.06 25.21 31.33 25.21 32.74 23.63 34.17 25.21 38 25.21 38 23.89 35.3 21.03 38 18.14 38 16.79 34.17 16.79 32.74 18.37 31.33 16.79 18.59 16.79 17.82 18.95 17.05 16.79 12.59 16.79 12.59 19.67 11.32 16.79 7.71 16.79",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39,17.7,5.48,24.27h2L8,23h3l.54,1.31h3.8V19.76L17,24.27h1.59l1.64-4.5v4.51H22V17.7h-2.7l-1.46,4.05-1.44-4H13.58v6.51L10.7,17.7Zm20.17,6.59L31.62,21l-3.06-3.25v1.48H24.8v1h3.67v1.49H24.8v1h3.76v1.5Zm0-6.54h2.36l1.89,2.08,1.88-2.08H37v.05L34,21l3,3.19v.1H34.67l-1.92-2.11-1.9,2.11H23V17.75h5.57ZM8.64,21.48l.88-2.09.87,2.09Z",
    fill: "#006fcf",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.7ada76b5c87584dfb9a4fd5c795d4d05.svg";
export { ForwardRef as ReactComponent };